import { UPDATE_SMART_TEMPLATES } from "../actionTypes";
import { updateState } from "../utils";

const initialState = {
    smartTemplates: null,
};

const updateSmartTemplates = (state, action) => {
    return updateState(state, {
        smartTemplates: action.smartTemplates,
    });
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case UPDATE_SMART_TEMPLATES:
            return updateSmartTemplates(state, action);
        default:
            return state;
    }
};

export default reducer;